module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [(!_vm.loading) ? _c('div', [(_vm.user) ? _c('div', [_c('main-nav', {
    attrs: {
      "email": _vm.user.email
    }
  }), _vm._v(" "), _c('div', [_c('router-view', {
    attrs: {
      "id": "main"
    }
  })], 1)], 1) : _c('div', [_c('sign-in', {
    attrs: {
      "onClick": _vm.signIn
    }
  })], 1)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cad49406"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 222
// module chunks = 1